/* ============================================================
   AVORA HOME — Mobile Mega Menu (Behavior)
   Intercepts the default header-drawer trigger and shows
   an immersive overlay with glass blur transitions,
   search morph, product previews, and swipe navigation.
   ============================================================ */

(function() {
  'use strict';

  var overlay = document.getElementById('avora-mm-overlay');
  if (!overlay) return;

  var currentLayer = 'main';
  var scrollY = 0;
  var dataMap = null;
  var mainLayer = overlay.querySelector('[data-mm-layer="main"]');
  var drawerDetailsEl = null;
  var drawerSummaryEl = null;
  var lastDrilldownTrigger = null;
  var closeBtn = overlay.querySelector('[data-mm-close]');
  var searchTrigger = overlay.querySelector('[data-mm-search-trigger]');
  var searchCancel = overlay.querySelector('[data-mm-search-cancel]');
  var searchBar = overlay.querySelector('[data-mm-search]');
  var searchInput = overlay.querySelector('[data-mm-search-input]');
  var desktopMedia = window.matchMedia('(min-width: 750px)');
  var focusableSelector = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  /* ── Load collection data ── */
  try {
    var dataEl = document.getElementById('avora-collection-data');
    if (dataEl) dataMap = JSON.parse(dataEl.textContent);
  } catch (e) { /* silent */ }

  function getCollectionData(handle) {
    return handle && dataMap && dataMap[handle] ? dataMap[handle] : null;
  }

  function setAvailable(element, available) {
    if (!element) return;
    element.setAttribute('aria-hidden', available ? 'false' : 'true');
    if (available) {
      element.removeAttribute('inert');
    } else {
      element.setAttribute('inert', '');
    }
  }

  function setActiveLayer(activeLayer) {
    overlay.querySelectorAll('.avora-mm-layer').forEach(function(layer) {
      setAvailable(layer, layer === activeLayer);
    });
  }

  function getFocusableElements() {
    return Array.from(overlay.querySelectorAll(focusableSelector)).filter(function(element) {
      return !element.closest('[inert]') && element.getClientRects().length > 0;
    });
  }

  /* ── Intercept the default header-drawer ── */
  function interceptDrawer() {
    /* Find the default drawer's trigger (summary element) */
    var drawerDetails = document.querySelector('.header__drawer details, header-drawer details');
    if (!drawerDetails) return;

    var summary = drawerDetails.querySelector('summary');
    if (!summary) return;

    drawerDetailsEl = drawerDetails;
    drawerSummaryEl = summary;

    /* Prevent the default details/summary toggle */
    summary.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      /* Close the default drawer if it somehow opened */
      drawerDetails.removeAttribute('open');

      /* Toggle our overlay */
      if (overlay.classList.contains('is-open')) {
        closeMenu();
      } else {
        openMenu();
      }
    }, true);

    /* Also prevent the details element from opening */
    drawerDetails.addEventListener('toggle', function() {
      if (drawerDetails.open) {
        drawerDetails.removeAttribute('open');
      }
    });
  }

  /* ── Open ── */
  function openMenu() {
    scrollY = window.scrollY || window.pageYOffset || 0;
    document.body.classList.add('avora-mm-locked');
    document.body.style.top = '-' + scrollY + 'px';

    overlay.removeAttribute('inert');
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    if (drawerSummaryEl) drawerSummaryEl.setAttribute('aria-expanded', 'true');

    showMain(false, false);

    /* Stagger entrance for hero cards */
    var heroes = mainLayer.querySelectorAll('.avora-mm-hero');
    var utils = mainLayer.querySelector('.avora-mm-utils');

    heroes.forEach(function(h) { h.classList.add('is-entering'); });
    if (utils) utils.classList.add('is-entering');

    setTimeout(function() {
      heroes.forEach(function(h) { h.classList.remove('is-entering'); });
      if (utils) utils.classList.remove('is-entering');
    }, 1200);

    /* Move focus after the native summary click has finished its default focus step. */
    if (closeBtn) setTimeout(function() { closeBtn.focus(); }, 50);
  }

  /* ── Close ── */
  function closeMenu() {
    if (!overlay.classList.contains('is-open')) return;

    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    overlay.setAttribute('inert', '');
    if (drawerSummaryEl) drawerSummaryEl.setAttribute('aria-expanded', 'false');
    if (drawerDetailsEl) drawerDetailsEl.removeAttribute('open');

    /* Close search if open */
    closeSearch(false);

    document.body.classList.remove('avora-mm-locked');
    document.body.style.top = '';
    window.scrollTo(0, scrollY);

    currentLayer = 'main';
    if (lastDrilldownTrigger) lastDrilldownTrigger.setAttribute('aria-expanded', 'false');
    lastDrilldownTrigger = null;
    if (drawerSummaryEl) setTimeout(function() { drawerSummaryEl.focus(); }, 0);
  }

  /* ── Search morph ── */
  function openSearch() {
    if (!searchBar) return;
    searchBar.classList.add('is-active');
    setAvailable(searchBar, true);
    if (searchTrigger) searchTrigger.setAttribute('aria-expanded', 'true');
    if (searchInput) requestAnimationFrame(function() { searchInput.focus(); });
  }

  function closeSearch(restoreFocus) {
    if (!searchBar) return;
    searchBar.classList.remove('is-active');
    setAvailable(searchBar, false);
    if (searchTrigger) searchTrigger.setAttribute('aria-expanded', 'false');
    if (searchInput) searchInput.value = '';
    if (restoreFocus && searchTrigger) searchTrigger.focus();
  }

  /* ── Glass blur transitions ── */
  function showSub(layerId, trigger) {
    var subLayer = overlay.querySelector('[data-mm-layer="' + layerId + '"]');
    if (!subLayer) return;

    currentLayer = layerId;
    if (lastDrilldownTrigger) lastDrilldownTrigger.setAttribute('aria-expanded', 'false');
    lastDrilldownTrigger = trigger || null;
    if (lastDrilldownTrigger) lastDrilldownTrigger.setAttribute('aria-expanded', 'true');

    /* Clean stale classes */
    overlay.querySelectorAll('.avora-mm-layer').forEach(function(l) {
      l.classList.remove('is-blurring-out', 'will-enter');
    });

    /* Main blurs out */
    mainLayer.classList.remove('is-active');
    mainLayer.classList.add('is-blurring-out');

    /* Sub enters from blur */
    subLayer.classList.remove('is-active');
    subLayer.classList.add('will-enter');
    subLayer.offsetHeight; /* force reflow */
    subLayer.classList.remove('will-enter');
    subLayer.classList.add('is-active');
    setActiveLayer(subLayer);

    /* Stagger sub-links */
    var links = subLayer.querySelectorAll('.avora-mm-sub__link');
    links.forEach(function(l) { l.classList.add('is-entering'); });
    setTimeout(function() {
      links.forEach(function(l) { l.classList.remove('is-entering'); });
    }, 1000);

    /* Populate product previews */
    populateProducts(subLayer);

    subLayer.scrollTop = 0;
    var backButton = subLayer.querySelector('[data-mm-back]');
    if (backButton) setTimeout(function() { backButton.focus(); }, 0);
  }

  function showMain(animate, restoreFocus) {
    var activeSub = overlay.querySelector('.avora-mm-layer--sub.is-active');
    if (activeSub) {
      activeSub.classList.remove('is-active');
      if (animate) activeSub.classList.add('is-blurring-out');
    }

    mainLayer.classList.remove('is-blurring-out', 'will-enter');

    if (animate) {
      mainLayer.classList.add('will-enter');
      mainLayer.offsetHeight;
      mainLayer.classList.remove('will-enter');
    }

    mainLayer.classList.add('is-active');
    setActiveLayer(mainLayer);
    mainLayer.scrollTop = 0;
    currentLayer = 'main';

    if (lastDrilldownTrigger) {
      var trigger = lastDrilldownTrigger;
      trigger.setAttribute('aria-expanded', 'false');
      lastDrilldownTrigger = null;
      if (restoreFocus) trigger.focus();
    }
  }

  /* ── Product previews ── */
  function populateProducts(layer) {
    var container = layer.querySelector('[data-mm-products]');
    if (!container || container.children.length > 0) return;

    var handle = layer.dataset.collection;
    var data = getCollectionData(handle);
    if (!data || !data.products || !data.products.length) return;

    var label = document.createElement('div');
    label.className = 'avora-mm-sub__products-label';
    label.textContent = 'Featured';
    container.appendChild(label);

    var shown = 0;
    data.products.forEach(function(p, i) {
      if (!p.image || shown >= 4) return;
      shown++;

      var card = document.createElement('a');
      card.href = p.url;
      card.className = 'avora-mm-product is-entering';
      card.style.setProperty('--product-stagger', i);

      var img = document.createElement('img');
      img.src = p.image;
      img.alt = p.title;
      img.className = 'avora-mm-product__img';
      img.loading = 'lazy';
      card.appendChild(img);

      var panel = document.createElement('div');
      panel.className = 'avora-mm-product__panel';

      var name = document.createElement('span');
      name.className = 'avora-mm-product__name';
      name.textContent = p.title;
      panel.appendChild(name);

      var price = document.createElement('span');
      price.className = 'avora-mm-product__price';
      price.textContent = p.price;
      panel.appendChild(price);

      card.appendChild(panel);
      container.appendChild(card);
    });

    setTimeout(function() {
      container.querySelectorAll('.is-entering').forEach(function(el) {
        el.classList.remove('is-entering');
      });
    }, 1200);
  }

  /* ── Swipe navigation ── */
  function setupSwipe() {
    var startX = 0, startY = 0, swiping = false;

    overlay.querySelectorAll('.avora-mm-layer--sub').forEach(function(layer) {
      layer.addEventListener('touchstart', function(e) {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        swiping = true;
      }, { passive: true });

      layer.addEventListener('touchmove', function(e) {
        if (!swiping) return;
        if (Math.abs(e.touches[0].clientY - startY) > 30) swiping = false;
      }, { passive: true });

      layer.addEventListener('touchend', function(e) {
        if (!swiping) return;
        if (e.changedTouches[0].clientX - startX > 70) showMain(true, true);
        swiping = false;
      }, { passive: true });
    });
  }

  /* ── Bind events ── */
  function bindEvents() {
    /* Close button */
    if (closeBtn) closeBtn.addEventListener('click', closeMenu);

    /* Search */
    if (searchTrigger) searchTrigger.addEventListener('click', openSearch);
    if (searchCancel) searchCancel.addEventListener('click', function() { closeSearch(true); });

    /* Drilldown buttons */
    overlay.querySelectorAll('[data-mm-drilldown]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        showSub(btn.dataset.mmDrilldown, btn);
      });
    });

    /* Back buttons */
    overlay.querySelectorAll('[data-mm-back]').forEach(function(btn) {
      btn.addEventListener('click', function() { showMain(true, true); });
    });

    /* Keyboard state and focus containment */
    document.addEventListener('keydown', function(e) {
      if (!overlay.classList.contains('is-open')) return;

      if (e.key === 'Escape') {
        e.preventDefault();
        if (searchBar && searchBar.classList.contains('is-active')) {
          closeSearch(true);
        } else if (currentLayer !== 'main') {
          showMain(true, true);
        } else {
          closeMenu();
        }
        return;
      }

      if (e.key === 'Tab') {
        var focusable = getFocusableElements();
        if (!focusable.length) return;

        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        var active = document.activeElement;
        var movingBackward = e.shiftKey;

        if (!overlay.contains(active) || (movingBackward && active === first) || (!movingBackward && active === last)) {
          e.preventDefault();
          (movingBackward ? last : first).focus();
        }
      }
    });

    document.addEventListener('focusin', function(e) {
      if (!overlay.classList.contains('is-open') || overlay.contains(e.target)) return;

      var focusable = getFocusableElements();
      if (focusable.length) focusable[0].focus();
    });

    desktopMedia.addEventListener('change', function(event) {
      if (event.matches) closeMenu();
    });

    /* Swipe */
    setupSwipe();
  }

  /* ── Init ── */
  function init() {
    interceptDrawer();
    bindEvents();
    setActiveLayer(mainLayer);
    setAvailable(searchBar, false);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
